module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-slick slick-wrapper",
    attrs: {
      "id": "carousel-slick"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('lightbox', {
      key: image.title,
      attrs: {
        "caption": image.title,
        "src": image.src,
        "album": image.album
      }
    }, [_c('img', {
      attrs: {
        "src": image.src
      }
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2692a58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CarouselSlick.vue
// module id = 836
// module chunks = 1